import { Avatar, Dropdown, Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import logo from '../assets/images/logo.svg';
import { useAuth } from '../auth/AuthContext';
import { AUTH_ENABLED } from '../auth/authConfig';
import './Sidebar.css';

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const userMenuItems = AUTH_ENABLED
    ? [
      {
        key: 'logout',
        label: '退出登录',
      },
    ]
    : [
      {
        key: 'bypass',
        label: '免登录模式',
      },
    ];

  // 中文菜单按每行两个字拆分；中英混排（如 Agent管理）按“英文/中文”分行，保持视觉一致。
  const formatLabel = (text) => {
    const mixedMatch = String(text).match(/^([A-Za-z0-9]+)([\u4e00-\u9fa5]+)$/);
    if (mixedMatch) {
      return (
        <span>
          <span>{mixedMatch[1]}</span>
          <br />
          <span>{mixedMatch[2]}</span>
        </span>
      );
    }

    const chars = text.split('');
    const lines = [];

    for (let i = 0; i < chars.length; i += 2) {
      lines.push(chars.slice(i, i + 2).join(''));
    }

    return (
      <span>
        {lines.map((line, index) => (
          <span key={index}>
            {line}
            {index !== lines.length - 1 && <br />}
          </span>
        ))}
      </span>
    );
  };

  const menuItems = [
    {
      key: '/produce',
      label: formatLabel('内容生产'),
    },
    {
      key: '/content',
      label: formatLabel('内容管理'),
    },
    {
      key: '/timedPublish',
      label: formatLabel('任务管理'),
    },
    {
      key: '/users',
      label: formatLabel('账号管理'),
    },
    {
      key: '/agent/setup',
      label: formatLabel('Agent管理'),
    },
    {
      key: '/statistics',
      label: formatLabel('数据统计'),
    },
    {
      key: '/billing',
      label: formatLabel('付费订阅'),
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleUserMenuClick = async ({ key }) => {
    if (!AUTH_ENABLED) return;
    if (key === 'logout') {
      await logout();
      navigate('/');
      return;
    }
  };

  return (
    <Sider
      width={88}
      style={{
        overflow: 'hidden',
        height: '100vh',
        background: '#fff',
      }}
      theme="light"
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          role="button"
          tabIndex={0}
          onClick={handleLogoClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleLogoClick();
            }
          }}
          aria-label="返回首页"
          title="返回首页"
          style={{
            height: 56,
            margin: '5px 8px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 auto',
            cursor: 'pointer',
          }}
        >
          <img src={logo} alt="品牌Logo" style={{ height: 40, width: 'auto' }} />
          {/* <span style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>
            自动化运营平台
          </span> */}
        </div>
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <Menu
            theme="light"
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            className="custom-sidebar-menu"
          />
        </div>

        <div style={{ padding: 12, display: 'flex', justifyContent: 'center', flex: '0 0 auto' }}>
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="topRight">
            <Avatar
              src={user?.avatar}
              icon={!user?.avatar ? <UserOutlined /> : undefined}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;
